/*!
 * RedStar24 – Sidebar Mega Menu Helper für Enterprise 2.3.x
 * Öffnung läuft per CSS, Overlay/Sidebar-State wird hier stabilisiert.
 */
(function () {
  'use strict';

  var closeTimer = null;

  function isDesktop() {
    return window.matchMedia('(min-width: 769px)').matches;
  }

  function getOverlay() {
    return document.querySelector('.js-overlay');
  }

  function setMegaActive(active) {
    document.body.classList.toggle('rs-mega-active', !!active);
  }

  function cleanupEnterpriseOverlay() {
    var overlay = getOverlay();

    if (overlay) {
      overlay.classList.remove('overlay--nav', 'is-visible');
    }

    document.body.classList.remove('overflow-hidden', 'fixed');
  }

  function closeMegaMenus() {
    if (!isDesktop()) return;

    setMegaActive(false);
    cleanupEnterpriseOverlay();

    document.querySelectorAll('main-menu .main-nav__item--dropdown.is-open').forEach(function (item) {
      item.classList.remove('is-open', 'is-visible', 'is-closing');

      var toggle = item.querySelector(':scope > .main-nav__row .main-nav__toggle-btn');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function scheduleClose() {
    window.clearTimeout(closeTimer);

    closeTimer = window.setTimeout(function () {
      var stillHovering = document.querySelector(
        'main-menu .main-nav > .main-nav__item--dropdown:hover, main-menu .main-nav > .main-nav__item--dropdown:focus-within'
      );

      if (!stillHovering) {
        closeMegaMenus();
      }
    }, 120);
  }

  function activateSidebarItem(item) {
    if (!isDesktop()) return;

    var list = item.closest('.child-nav');
    if (!list) return;

    list.querySelectorAll('.child-nav__item--toggle.is-visible').forEach(function (other) {
      if (other !== item) {
        other.classList.remove('is-visible');
      }
    });

    item.classList.add('is-visible');

    var panel = item.querySelector('.child-nav__panel');
    if (panel) {
      list.style.setProperty('--sidebar-height', panel.scrollHeight + 'px');
    }
  }

  function init() {
    document.querySelectorAll('main-menu .main-nav > .main-nav__item--dropdown').forEach(function (item) {
      if (item.dataset.rsMegaInit === 'true') return;
      item.dataset.rsMegaInit = 'true';

      item.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;

        window.clearTimeout(closeTimer);

        if (item.querySelector('.mega-nav')) {
          setMegaActive(true);
        }
      });

      item.addEventListener('mouseleave', function () {
        scheduleClose();
      });

      item.addEventListener('focusin', function () {
        if (!isDesktop()) return;

        if (item.querySelector('.mega-nav')) {
          setMegaActive(true);
        }
      });

      item.addEventListener('focusout', function () {
        scheduleClose();
      });
    });

    document.querySelectorAll('main-menu .mega-nav--sidebar .child-nav__item--toggle').forEach(function (item) {
      if (item.dataset.rsSidebarInit === 'true') return;
      item.dataset.rsSidebarInit = 'true';

      item.addEventListener('mouseenter', function () {
        activateSidebarItem(item);
      });

      item.addEventListener('focusin', function () {
        activateSidebarItem(item);
      });
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') {
        closeMegaMenus();
      }
    });

    var overlay = getOverlay();
    if (overlay && overlay.dataset.rsMegaOverlayInit !== 'true') {
      overlay.dataset.rsMegaOverlayInit = 'true';
      overlay.addEventListener('mouseenter', closeMegaMenus);
      overlay.addEventListener('click', closeMegaMenus);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();